import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ConfigurableAuthService } from '@anothertrip/anothertrip-ds';

import { NavigationContextService } from '../../../../services/navigation-context.service';
import { MyCampaignsRedirectTrigger } from '../constants/redirect-trigger';

/**
 * Login gate for /campaigns/mine. Unlike the design-system `atAuthGuard` it remembers where the creator was
 * going, so the invite email link /campaigns/mine/{id} survives the login. The full `state.url` is kept:
 * login/register use `navigateByUrl`, so a query string survives too.
 */
export const myCampaignsAuthGuard: CanActivateFn = (_route, state) => {
  const router = inject(Router);

  if (inject(ConfigurableAuthService).isLoggedIn()) {
    return true;
  }

  inject(NavigationContextService).setContext(state.url, { trigger: MyCampaignsRedirectTrigger.RequireLogin });
  return router.createUrlTree(['/login']);
};
